import Vue from 'vue';
import Vuetify from 'vuetify/lib';

import colors from 'vuetify/lib/util/colors'

Vue.use(Vuetify);

export default new Vuetify({
  icons: {
    iconfont: 'mdi',
  },
  theme: {
    themes: {
      light: {
        primary: '#FC9861',
        secondary: '#31307A',
        inactive: '#C9C9C9',
        white: '#FFFFFF',
        background: '#F5F5F5',
        bg_light: '#FDFCFC',
        gray: '#6F6F6F',
        gray_2: '#AAAAAA',
        gray_3: '#A9A9A9',
        gray_4: '#E8E8E8',
        gray_5: '#F2F2F2',
        gray_s: '#F2F2F2',
        gray_m: '#A9A9A9',
        tr_red: '#ED484F',
        tr_yellow: '#ECB66C',
        tr_green: '#23B480',
        tr_red_m: '#F5A3A6',
        tr_yellow_m: '#F4D9B5',
        tr_green_m: '#90D8BE',
        tr_red_s: '#FADFE0',
        tr_yellow_s: '#F9F1E5',
        tr_green_s: '#D9F0E8',
        violet: '#8B5AF4',
        violet_m: '#C5ACF9',
        violet_s: '#F3EFFE',
        lightgreen: '#43D9AF',
        lightgreen_m: '#A1ECD7',
        lightgreen_s: '#ECFBF7',
        pink: '#FF7299',
        pink_m: '#FFB8CC',
        pink_s: '#FFF1F5',
        lightblue: '#A3BCEB',
        lightblue_m: '#D1DDF5',
        lightblue_s: '#F6F8FD',
      }
    },
    options: {
      customProperties: true
    },
  },
})
